/** Asset texels and world pixels share one grid. Padding is NOT body scale. */
export const PIXEL_WORLD = 1 / 48;
export const HUMAN_CELL = { width: 144, height: 80 } as const;
export const MONSTER_CELL = { width: 128, height: 96 } as const;
export const BOSS_CELL = { width: 256, height: 128 } as const;
export const HORSE_CELL = { width: 192, height: 96 } as const;

export function displayGrid(width: number, height: number) {
  const scale = width < 900 ? 2 : Math.max(2, Math.floor(height / 360));
  const bufferWidth = Math.ceil(width / scale);
  const bufferHeight = Math.ceil(height / scale);
  return { scale, bufferWidth, bufferHeight, cssWidth: bufferWidth * scale, cssHeight: bufferHeight * scale };
}
